import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { LoginModel } from 'src/app/models/login.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { faX } from '@fortawesome/free-solid-svg-icons'; // O far para regular
import { RegisterComponent } from 'src/app/components/modals/register/register.component';
import { RecoverPasswordComponent } from 'src/app/components/modals/recover-password/recover-password.component';
import { InfoMessageService } from 'src/app/services/info-message.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  @Input() title = '';
  @Input() msg = '';
  @Input() btn_msg_yes = '';
  @Input() btn_msg_no = '';
  @Input() callback_yes = () => { };
  @Input() callback_no = () => { };
  loginFormGroup: RxFormGroup;
  isLogin = false;
  faClose = faX;
  typePassword: boolean = true; // Or initialize as needed
  modalCarga?: NgbModalRef;
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  private loginSubscription: Subscription;
  constructor(public activeModal: NgbActiveModal, private fb: RxFormBuilder,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private messageService: InfoMessageService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.initForm();
  }
  async initForm(): Promise<void> {
    return new Promise((resolve) => {
      const loginModel = new LoginModel();
      this.loginFormGroup = (this.fb.formGroup(loginModel) as RxFormGroup);

      resolve();
    });
  }
  login() {
    const { email, password } = this.loginFormGroup.value;

    if (email && password) {
      this.isLogin = true; // Show loader or spinner

      this.loginSubscription = this.authService.login(email, password).subscribe({
        next: async (response) => {
          await this.authService.setData(response);
          this.isLogin = false;
          this.onYes(); 
        },
        error: (error) => {
          console.error('Login error:', error);
          this.isLogin = false;
        }
      });
    } else {
      this.loginFormGroup.markAllAsTouched();
    }
  }
  recoverPass() {
    this.activeModal.close('register');
    this.modalCarga = this.modalService.open(RecoverPasswordComponent, this.ngbModalOptions);
    this.modalCarga.result.then(() => {
    }, () => {
      this.activeModal.close('login');
      this.callback_yes();
    });
  }
  createAccount() {
    this.activeModal.close('register');
    this.modalCarga = this.modalService.open(RegisterComponent, this.ngbModalOptions);
    this.modalCarga.result.then(() => {
    }, () => {
      this.activeModal.close('login');
      this.callback_yes();
    });
  }
  onYes() {
    this.activeModal.close('login');
    this.callback_yes();
    // this.messageService.showMessage(
    //   "¡Te damos la bienvenida!",
    //   "Has iniciado sesión correctamente.",
    //   "success"
    // );
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  onNo() {
    this.activeModal.close('close');
    this.callback_no();
  }

  onEmailInput(eventData: any){
    const inputElement = eventData.target as HTMLInputElement;
    const value = inputElement.value;

    const isNumber = this.isNumber(value);

    if(isNumber && value.length > 10){
      this.loginFormGroup.get('email')?.setValue(
        inputElement.value.substring(0,10)
      );
    }
  }

  isNumber(value: string){
    return /^-?\d*\.?\d+$/.test(value);
  }

  ngOnDestroy(){
    // this.messageService.hideActiveMessage();
    if(this.loginSubscription){
      this.loginSubscription.unsubscribe();
    }
  }
}
